import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  async upload(request: RequestUpload): Promise<AxiosResponse<ResponseUpload>> {
    const response: AxiosResponse<ResponseUpload> = await client.post<ResponseUpload>('face_front_photos', request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async images(faceFrontPhotoId: number): Promise<AxiosResponse<ResponseImages>> {
    const response: AxiosResponse<ResponseImages> = await client.get<ResponseImages>(
      `face_front_photos/${faceFrontPhotoId}`,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async confirm(faceFrontPhotoId: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `face_front_photos/${faceFrontPhotoId}/update_confirmed_result`,
      null,
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface RequestUpload {
  imageBase64: string;
}

export interface ResponseUpload {
  faceFrontPhotoID: number;
}

export interface ResponseImages {
  imageBase64: string;
}
